/**
 * ActionCard styles
 * Shared card chrome for Invite and Create-group cards (same aspect ratio, border, background).
 */

import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

/** Match FriendCard aspect ratio so action cards are identical size in the grid. */
export const FRIEND_CARD_ASPECT_RATIO = 0.85
/** Semi-transparent background so card does not read as solid. */
const CARD_BG_OPACITY = '22'
/** Half-transparent border (soft outline like filter button). */
const CARD_BORDER_OPACITY = '80'
/** Hover: slightly stronger background and border. */
const CARD_BG_OPACITY_HOVER = '44'
const CARD_BORDER_OPACITY_HOVER = 'CC'

export const getActionCardStyles = (theme: Theme) =>
  StyleSheet.create({
    card: {
      width: '100%',
      borderRadius: 20,
      backgroundColor: theme.primary + CARD_BG_OPACITY,
      borderWidth: 1,
      borderColor: theme.primary + CARD_BORDER_OPACITY,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.12,
      shadowRadius: 8,
      elevation: 6,
      overflow: 'hidden',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 12,
    },
    cardPressed: { opacity: 0.85 },
    cardHover: {
      backgroundColor: theme.primary + CARD_BG_OPACITY_HOVER,
      borderColor: theme.primary + CARD_BORDER_OPACITY_HOVER,
    },
    iconWrap: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    label: {
      fontSize: 17,
      fontWeight: '700',
      color: theme.primary,
    },
  })
